import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import Modal, { ModalProps } from "@mui/material/Modal";

import { Button } from "../../forms";

import "./GeneralModal.styles.scss";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)"
};

type BtnProps = {
  text: string;
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
};

type GeneralModalProps = ModalProps & {
  title: string;
  onClose: () => void;
  positiveBtn?: BtnProps;
  negativeBtn?: BtnProps;
};

export const GeneralModal: React.FC<GeneralModalProps> = (props) => {
  const { title, positiveBtn, negativeBtn, onClose, ...modalProps } = props;

  return (
    <Modal {...modalProps} onClose={onClose}>
      <Box sx={style}>
        <div data-testid="general-modal" className="general-modal opacity-appearance">
          <div className="general-modal__head">
            <div className="general-modal__head-content flex-row-sb-fc">
              <span>{title}</span>
              <IconButton onClick={onClose}>
                <CloseIcon className="icon" />
              </IconButton>
            </div>
          </div>
          <div className="general-modal__body flex-col-sb-st">
            {modalProps.children}
            <div className="general-modal__btns-block flex-rowr-fs-fc">
              {positiveBtn && (
                <Button
                  className="general-modal__btn"
                  title={positiveBtn.text}
                  isLoading={positiveBtn.loading}
                  onClick={positiveBtn.onClick}
                  disabled={positiveBtn.disabled}
                />
              )}
              {negativeBtn && (
                <Button
                  className="general-modal__btn"
                  variant="light-border"
                  title={negativeBtn.text}
                  isLoading={negativeBtn.loading}
                  onClick={negativeBtn.onClick}
                  disabled={negativeBtn.disabled}
                />
              )}
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};
